export const Monogram = ({ size = 40, className = "" }) => (
  <img src="/logo-150.png" width={size} height={size} alt="DDVINTAGE CO" className={`rounded-full object-cover ${className}`} />
);

export const Logo = ({ compact = false, className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <Monogram size={compact ? 36 : 44} />
    {!compact && (
      <span className="leading-none">
        <span className="block whitespace-nowrap font-display text-2xl tracking-[0.12em] text-white">DDVINTAGE CO</span>
      </span>
    )}
  </span>
);
